export default __webpack_public_path__ + "static/media/404-graphic.a0a621f8.svg";